"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.skipButton = exports.addButton = exports.toggleOpen = exports.close = exports.setOpen = exports.isOpen = exports.get = void 0;
var spritesUiGame_1 = require("@crokinole/recyclers/spritesUiGame");
var crokinoleMenuCreator_sidecar_1 = require("@crokinole/to-engine/crokinoleMenuCreator-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var crokinoleUi_menu_gameEsc_sidecar_1 = require("./crokinoleUi_menu_gameEsc-sidecar");
var crokinoleUi_menu_players_sidecar_1 = require("./crokinoleUi_menu_players-sidecar");
var fullscreen_sidecar_1 = require("@engine/fullscreen-sidecar");
var debug_menuMode = 'game-esc';
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var obj = {
        // isOpen: true,
        menuMode: debug_menuMode,
        mcsx: 40,
        mcsy: 200,
        mcx: 40,
        mcy: 200,
        mch: 60,
        mcw: 350,
        mcox: 40,
        mcoy: 30,
    };
    return obj;
};
var isOpen = function () {
    var menuMode = get().menuMode;
    return menuMode !== 'none' && menuMode !== 'in-game';
};
exports.isOpen = isOpen;
var setOpen = function (menuMode) {
    var obj = get();
    obj.menuMode = menuMode;
    if (exports.isOpen()) {
        // chessMusic.playMusicMenu()
    }
    else {
        // chessMusic.playMusic1()
    }
    // update()
};
exports.setOpen = setOpen;
var close = function () {
    exports.setOpen('none');
};
exports.close = close;
var toggleOpen = function (mode, toggleMode) {
    var obj = get();
    if (obj.menuMode === mode) {
        exports.setOpen(toggleMode);
    }
    else {
        exports.setOpen(mode);
    }
};
exports.toggleOpen = toggleOpen;
var addButton = function (id, text, onClick, isDisabled, adjY) {
    if (isDisabled === void 0) { isDisabled = false; }
    if (adjY === void 0) { adjY = 100; }
    var _a = get(), mcx = _a.mcx, mcy = _a.mcy, mch = _a.mch, mcw = _a.mcw, mcox = _a.mcox, mcoy = _a.mcoy;
    var mc = crokinoleMenuCreator_sidecar_1.crokinoleMenuCreator;
    var b = mc.addButton(id, text, mcx, mcy, mcw, mch, mcox, mcoy, onClick);
    b.isDisabled = isDisabled;
    get().mcy += adjY;
    return b;
};
exports.addButton = addButton;
var skipButton = function (adjY) {
    if (adjY === void 0) { adjY = 100; }
    get().mcy += adjY;
};
exports.skipButton = skipButton;
var update = function () {
    var mainMenu = get();
    mainMenu.mcy = mainMenu.mcsy;
    mainMenu.mcx = mainMenu.mcsx;
    var menuMode = mainMenu.menuMode;
    var isMultiplayerOpen = menuMode === 'multiplayer';
    var isOptionsOpen = menuMode === 'options';
    var isGameOptionsOpen = menuMode === 'game-options';
    var isPlayersOpen = menuMode === 'players-lobby';
    var isGameEscOpen = menuMode === 'game-esc';
    var isMainOpen = menuMode === 'main-menu'; //!isPlayersOpen && !isGameEscOpen
    var showMain = isMainOpen || isOptionsOpen || isMultiplayerOpen;
    // (!isMultiplayerOpen &&
    //   !isOptionsOpen &&
    //   !isPlayersOpen &&
    //   !isGameEscOpen &&
    //   menuMode !== 'in-game' &&
    //   menuMode !== 'none')
    // Render our title
    if (showMain || isPlayersOpen || isGameEscOpen) {
        spritesUiGame_1.spritesUiGame.getNext(200, 100, sprites_sidecar_1.sprites.crokinoleCrokinoleTitle[0]);
    }
    if (showMain) {
        //if (mainMenu.isOpen) {
        // voyageCamera.setCameraXY(-800, -800)
        exports.addButton('new-local', 'New Local Game', function () {
            exports.toggleOpen('players-lobby', 'main-menu');
        }, !isMainOpen);
        var bOnline = exports.addButton('new-online', 'New Online Game', function () {
            exports.toggleOpen('multiplayer', 'main-menu');
        }, !isMainOpen && !isMultiplayerOpen);
        bOnline.isHighlighted = isMultiplayerOpen;
        var bOptions = exports.addButton('options', 'Options', function () {
            exports.toggleOpen('options', 'main-menu');
        }, !isMainOpen && !isOptionsOpen);
        bOptions.isHighlighted = isOptionsOpen;
        exports.addButton('credits', 'Credits / Website', function () {
            window.open('https://keepflyinggames.com/crokinole/credits');
        }, !isMainOpen);
        exports.addButton('news', 'News', function () {
            window.open('https://keepflyinggames.com/crokinole/news');
        }, !isMainOpen);
    }
    if (isGameEscOpen) {
        crokinoleUi_menu_gameEsc_sidecar_1.crokinoleUi_menu_gameEsc.updateGameEscMenu();
    }
    if (isPlayersOpen) {
        crokinoleUi_menu_players_sidecar_1.crokinoleUi_menu_players.updatePlayersMenu();
    }
    if (isMultiplayerOpen) {
        mainMenu.mcy = mainMenu.mcsy;
        mainMenu.mcx += mainMenu.mcw + 20;
        exports.addButton('multi-host', 'Host', function () { }, !isMultiplayerOpen);
        exports.addButton('multi-join', 'Join', function () { }, !isMultiplayerOpen);
        exports.addButton('multi-cancel', 'Cancel', function () {
            exports.setOpen('main-menu');
        }, !isMultiplayerOpen);
    }
    var isAnyOptionsOpen = isOptionsOpen || isGameOptionsOpen;
    if (isAnyOptionsOpen) {
        mainMenu.mcy = mainMenu.mcsy;
        mainMenu.mcx += mainMenu.mcw + 20;
        exports.addButton('options-fullscreen', 'Fullscreen', function () {
            fullscreen_sidecar_1.fullscreen.toggleFullscreen();
        }, !isAnyOptionsOpen);
        exports.addButton('options-a', 'Option A', function () { }, !isAnyOptionsOpen);
        exports.addButton('options-b', 'Option B', function () { }, !isAnyOptionsOpen);
        exports.addButton('options-cancel', 'Cancel', function () {
            if (isOptionsOpen) {
                exports.setOpen('main-menu');
            }
            if (isGameOptionsOpen) {
                exports.setOpen('game-esc');
            }
        }, !isAnyOptionsOpen);
    }
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    if (menuMode !== 'in-game' && menuMode !== 'none') {
        clickEater_sidecar_1.clickEater.tempEatCursor();
    }
    // TOOD: do a hit bounds for this?
};
exports.update = update;
//}
